
export function lastMonthDate() {
    const objToday = new Date();
    const lastDayOfMonth = new Date(objToday.getFullYear(), objToday.getMonth() + 1, 0);

    const months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
    const curMonth = months[objToday.getMonth()];
    const today = `${lastDayOfMonth.getDate()} ${curMonth}`;

    return today;
}

export function getCurrentYear() {
    return new Date().getFullYear();
}

export const __STOPLIST__ = {
    'Company_Name': [
        'Avvocato',
        'Avv.',
        'Studio legale',
        'Libero professionista',
        'Dottore',
        'Medico',
        'Architetto',
    ],
} as const;
